import React from 'react';
import PropTypes from 'prop-types';

const FormHidden = ({
  groupId,
  parentElementClass,
  inputName,
  inputValue
  }) => {

  function generateMarkup() {
    if (parentElementClass) {
      return (
        <div className={parentElementClass}>
          <input
            type="hidden"
            name={inputName}
            value={inputValue}
            data-groupid={groupId}
          />
        </div>
      );
    }

    return (
      <input
        type="hidden"
        name={inputName}
        value={inputValue}
        data-groupid={groupId}
      />
    );
  }

  return (
    <>
      { generateMarkup() }
    </>
  );
};

FormHidden.propTypes = {
  "groupId": PropTypes.string,
  "parentElementClass": PropTypes.string,
  "inputName": PropTypes.string.isRequired,
  "inputValue": PropTypes.string
};

export default FormHidden;